// extracted by mini-css-extract-plugin
module.exports = {"root":"_c61ec8","titleHeadingExp":"_7047d4","contender":"_d8685a","logo":"_72aee8","info":"_3d8b71","nameWrapper":"_b34803","name":"_90cb20","rating":"_4baeba"};